import React from 'react'

/** Production stub. During `gatsby develop`, webpack aliases this to the real provider. */
export const DevDocRoot = ({ children }) => <>{children}</>
